import React, { createContext, useState } from 'react';
import { Trail } from '../types/trail';
import { HomepageOverview } from '../types/overview';

interface LocationContextType {
    location: string;
    setLocation: (location: string) => void;
    trails: Trail[];
    setTrails: (trails: Trail[]) => void;
    triggerGetTrails: boolean;
    setTriggerGetTrails: (trigger: boolean) => void;
    homepageOverview: HomepageOverview | null;
    setHomepageOverview: (overview: HomepageOverview | null) => void;
    activitiesLoaded: boolean;
    setActivitiesLoaded: (loaded: boolean) => void;
    activitiesLoading: boolean;
    setActivitiesLoading: (loading: boolean) => void;
    activitiesError: string | null;
    setActivitiesError: (error: string | null) => void;
}

export const LocationContext = createContext<LocationContextType>({} as LocationContextType);

export const LocationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [location, setLocation] = useState('');
    const [trails, setTrails] = useState<Trail[]>([]);
    const [triggerGetTrails, setTriggerGetTrails] = useState(false);
    const [homepageOverview, setHomepageOverview] = useState<HomepageOverview | null>(null);
    const [activitiesLoaded, setActivitiesLoaded] = useState(false);
    const [activitiesLoading, setActivitiesLoading] = useState(false);
    const [activitiesError, setActivitiesError] = useState<string | null>(null);

    return (
        <LocationContext.Provider value={{ location, setLocation, trails, setTrails, triggerGetTrails, setTriggerGetTrails, homepageOverview, setHomepageOverview, activitiesLoaded, setActivitiesLoaded, activitiesLoading, setActivitiesLoading, activitiesError, setActivitiesError }}>
            {children}
        </LocationContext.Provider>
    );
};
